import type { PropsWithChildren } from 'react';
import { createContext } from 'react';

import { useEnsureContextWithinProvider } from './hooks/useEnsureContextWithinProvider';

interface JaneModeContext {
  isJaneMode: boolean;
}

/**
 * "Jane Mode" refers to applying the default theme, when a store does not have a custom theme color.
 * Jane Mode is currently designed to include:
 *   1. White landing page with black buttons
 *   2. Ultralight header
 *   3. Brand Purple primary buttons (Add to bag, Search, etc.)
 */
const JaneModeContext = createContext<boolean | null>(null);

export const JaneModeProvider = ({
  children,
  isJaneMode,
}: PropsWithChildren<JaneModeContext>) => {
  return (
    <JaneModeContext.Provider value={isJaneMode}>
      {children}
    </JaneModeContext.Provider>
  );
};

export const useKioskJaneModeContext = () =>
  useEnsureContextWithinProvider(JaneModeContext, 'JaneMode');
